import { Injectable } from '@angular/core';
import { map, shareReplay, Subscription } from 'rxjs';
import { LoginService } from '../LoginService/login.service';
import { Router } from '@angular/router';
import { DataService } from '../DataService/data.service';
import { HelperService } from '../HelperService/helper.service';
import { LocalStorage, MenuItems, Modules } from '../../appCommon/Enums/enum';
import { ToasterService } from '../ToasterService/toaster.service';
import { PiteamService } from '../DefineService/piTeam-service';
import { environment } from 'src/environments/environment';
import { CrossTabService } from '../CrossTabService/crossTab.service';
// import { environment } from 'src/environments/environment.prod';
let GenerateTokenBefore = environment.refreshTokenTimeBefore;
@Injectable({
  providedIn: 'root',
})

export class AuthService {
  subscriptions: Subscription[] = [];
  isLoginFailed: boolean = false;
  _IsTokenNotAvailable: boolean = false;
  _isTokenExpire: boolean = false;
  UserName = "";
  UserCredentials: any;
  roleAccessResult:any = [];
  roleAccessResultTemp:any = [];
  roleList:any = [];
  //roleName: any;

  constructor(
    private loginService: LoginService,
    private router: Router,
    private dataService: DataService,
    private helperService: HelperService,
    private toast: ToasterService,
    public PiTeamService: PiteamService,
    private crossTabService: CrossTabService
  ) { }

  login(user_name: any, roleId: any, roleName: any, _env: any) {

    if (!localStorage.getItem(LocalStorage.token)) {
      this._IsTokenNotAvailable = true;
    }

    if (this.isTokenExpired()) {
      this._isTokenExpire = true;
    }

    if (this._IsTokenNotAvailable == true) {
      localStorage.clear();
      this.UserCredentials = [
        {
          key: 'user_name',
          value: user_name,
        },
        {
          key: 'tokenNeeded',
          value: true
        },
        {
          key: 'userRoleId',
          value: roleId
        },
        {
          key: '_env',
          value: _env
        }
      ];
      this._Login(this.UserCredentials, roleName);
    }
    else if (this._IsTokenNotAvailable == false && this._isTokenExpire == true) {
      localStorage.clear();
      this.UserCredentials = [
        {
          key: 'user_name',
          value: user_name,
        },
        {
          key: 'tokenNeeded',
          value: true
        },
        {
          key: 'userRoleId',
          value: roleId
        },
        {
          key: '_env',
          value: _env
        }
      ];
      this._Login(this.UserCredentials, roleName);
    }
    else {
      this.UserCredentials = [
        {
          key: 'user_name',
          value: user_name,
        },
        {
          key: 'tokenNeeded',
          value: false
        },
        {
          key: 'userRoleId',
          value: roleId
        },
        {
          key: '_env',
          value: _env
        }
      ];
      this._Login(this.UserCredentials, roleName);
    }
  }

  private setTokenAndLogin(token: any) {
    this.setLoggedIn(true);
    this.setTokenExpiry(token.expires_in);
    this.setToken(token.access_token);
  }

  _Login(object: any, roleName: any) {
    return new Promise((resolve, reject) => {
      this.subscriptions.push(
        this.loginService.login(object).subscribe({
          next: (res: any) => {
            if(res.data === '' && res.msg.toLowerCase() === 'invalid qms access'){
                window.location.href = environment.teleUrl;
            }else{
            let roleAccessResultTemp = res.roleAccessResult;
            roleAccessResultTemp.push({
              cac_isAllowed: true,
              cac_key: 8847,
              cac_roleid: null,
              com_key: 7740,
              com_module_name: "dashboard",
              com_moduleimage: null,
              com_page_name: "dashboard",
              com_page_title: "dashboard",
              com_parentcomponentid: null
            });
            this.roleAccessResultTemp = roleAccessResultTemp;
            this.RoleAccessValidation(this.roleAccessResultTemp);

            if (res.data && res.msg == "Success") {
              if (res.data.IsActive == true) {
                if (this._IsTokenNotAvailable == true) {
                  this._IsTokenNotAvailable = false;
                  var tokenData = JSON.parse(res.token);
                  this.setTokenAndLogin(tokenData);
                }
                else if (this._IsTokenNotAvailable == false && this._isTokenExpire == true) {
                  this._IsTokenNotAvailable = false;
                  this._isTokenExpire = false;
                  var tokenData = JSON.parse(res.token);
                  this.setTokenAndLogin(tokenData);
                }
                this.UserName = res.data.FirstName.concat(' ').concat(res.data.LastName);
                localStorage.setItem(LocalStorage.UId, this.helperService.ecryption(res.data.Id))
                localStorage.setItem(LocalStorage.UName, this.helperService.ecryption(res.data.UserName));
                localStorage.setItem(LocalStorage.UserFullName, this.helperService.ecryption(this.UserName));
                localStorage.setItem(LocalStorage.UserImageUrl, this.helperService.ecryption(res.data.userImage));
                this.crossTabService.sendMessage('refresh', null);
                this.toast.logedInSuccessfully();
                this.router.navigate(['/Dashboard']);
                resolve(res);
              }
              if(!environment.production) // for local host only (for testing purpose)
              {
              //this.roleList = res.data.roleList;
             // this.roleList.forEach((item:any) => {
               // if(item.RoleName == 'Super Admin'){
                  // this.roleName = item.RoleName;
                  // this.roleName = this.roleName.replace(/\s/g, "");
                   //localStorage.setItem(LocalStorage.UserRoleName, this.helperService.ecryption(this.roleName));
              localStorage.setItem(LocalStorage.UserRoleName, this.helperService.ecryption(roleName.replace(/ /g, '').toLowerCase()));

               // }
             // });
            }
            else
            {
              localStorage.setItem(LocalStorage.UserRoleName, this.helperService.ecryption(roleName.replace(/ /g, '').toLowerCase()));
            }
            }
            else if (!res.data && res.msg == "Invalid username/password") {
              this.router.navigate([Modules.ErrorPage]);
            }   
          }       
          },
          error: (err: any) => {
          },

        })
      );
    });
  }

  private RoleAccessValidation(roleAccessResultTemp: any[]) {
    const restrictedPages: { [key: string]: string[] } = {
      [MenuItems.Define]: [MenuItems.RolesAssignment, MenuItems.QMSUsers, MenuItems.FacilityBenchmarks, MenuItems.FacilitySpecs, MenuItems.StandardProcess],
      [MenuItems.PiTeam]: [MenuItems.RolesAssignment, MenuItems.QMSUsers],
      [MenuItems.Measure]: [MenuItems.CaseFollowUp],
      [MenuItems.Analyze]: [MenuItems.FacilityPI, MenuItems.RCA],
      [MenuItems.Improve]: [MenuItems.PIReports],
      [MenuItems.Control]: [MenuItems.StrokeQualityMetrics, MenuItems.MRS, MenuItems.QMSReports, MenuItems.RapidiTrending],
      [MenuItems.QMSReports]: [MenuItems.StrokeQualityMetrics, MenuItems.MRS],
    };
 
    roleAccessResultTemp.forEach((item: any) => {
      Object.entries(restrictedPages).forEach(([pageTitle, restrictedTitles]) => {
          if ( item.com_page_title === pageTitle && item.cac_isAllowed === false ) {
            const roleAccessMap = new Map(roleAccessResultTemp.map((item) => [item.com_page_title, item]));
            restrictedTitles.forEach((restrictedTitle) => {
              const restrictedItem = roleAccessMap.get(restrictedTitle);
              if (restrictedItem) {
                restrictedItem.cac_isAllowed = false;
              }
            });
          }
        }
      );
    });
 
    localStorage.setItem('roleAccessResult', this.helperService.ecryption(JSON.stringify(roleAccessResultTemp)));
  }

  roleForFacility(): boolean {
    const RoleName = this.helperService.decryption(localStorage.getItem(LocalStorage.UserRoleName));
    return RoleName.includes('facility');
  }

  setLoggedIn(value: boolean) {
    localStorage.setItem(LocalStorage.isLogIn, this.helperService.ecryption(value.toString()));
  }

  isLoggedIn() {
    const isLogin = this.helperService.decryption(localStorage.getItem("isLogIn"));

    if (isLogin) {
      return isLogin;
    }

    return isLogin ?? false;
  }


  setToken(token: string) {
    localStorage.setItem(LocalStorage.token, token);
  }

  private setTokenExpiry(time: number) {
    let newExpirytime = new Date();
    newExpirytime.setMinutes(newExpirytime.getMinutes() + (time / 60));
    newExpirytime = new Date(newExpirytime);
    localStorage.setItem(LocalStorage.tokenExpiry, this.helperService.ecryption(newExpirytime.toString()));
  }

  getTokken() {
    const token = localStorage.getItem(this.dataService.gettingLocalStorageKeys(LocalStorage.token));
    if (token) {
      return token;
    }
    return token ?? false;
  }

  isTokenExpired() {
    var tokenExpiry = this.getTokenExpiry();
    if (!tokenExpiry) {
      return true;
    }
    
    const expiryTime: any = new Date(tokenExpiry);
    const currentTime: any = new Date();
    if(expiryTime < currentTime){
      return expiryTime < currentTime ? (true && this.logout()) : false;
    }else{
      expiryTime.setMinutes(expiryTime.getMinutes() - GenerateTokenBefore);
      return expiryTime > currentTime ? false : true;
    }
    
  }

  private getTokenExpiry(): number {
    const expTime = this.helperService.decryption(localStorage.getItem(this.dataService.gettingLocalStorageKeys(LocalStorage.tokenExpiry)));

    if (expTime) {
      return expTime;
    }
    return expTime ?? null;

  }

  refreshToken() {
    if (this.isTokenExpired()) {
      this.loginService.getToken().subscribe({
        next: (res: any) => {
          if (res) {
            var tokenData = JSON.parse(res.token);
            this._IsTokenNotAvailable = false;
            this._isTokenExpire = false;
            this.setLoggedIn(true);
            this.setTokenExpiry(tokenData.expires_in);
            this.setToken(tokenData.access_token);
          }
        },
        error: (err: any) => {
        },
      });
    }
  }

  logout() {
    window.localStorage.clear();
    this.subscriptions.forEach((sub: any) => {
      sub.unsubscribe();
    });
    if(!environment.production)
    {
      this.router.navigate([Modules.Login]);
    }
    else
    {
      this.router.navigate([Modules.LogOut]);
    }
    this.crossTabService.sendMessage('refresh', null);
  }

  loginScreen() {
    this.router.navigate(['/']);
  }
}
